// @flow
import * as React from 'react';
import PRESENCES, { OFFLINE } from 'esm-web-pro/containers/panels/calling/presence/presences';
import { getUser } from 'speed-js-react';
import { useSelector } from 'react-redux';
import { getOperatorsState } from 'esm-web-pro/redux/callings';


type Props = {
    children: Function,
};

const Presence = (props: Props) => {
    const { children } = props;
    const user = useSelector(getUser);
    const operators = useSelector(getOperatorsState);

    const operator = operators[user.uuid];
    const status = operator?.status || OFFLINE;

    return children(PRESENCES[status].color);
};

export default Presence;
